import s from "./style.module.css";
import {
    principlesImages,
    principlesImagesAltText,
} from "@/data/design-principles";
export interface Input {
    activeIndex: number;
}
static const IMAGE_COUNT = 4;

<div
    class=s.container
    style=[`--image-count: ${IMAGE_COUNT}`]
    role="img"
    aria-label=principlesImagesAltText[input.activeIndex]>
    <div class=s.stack>
        <for|group, i| of=principlesImages>
            <div
                class=s.imageGroup
                style=[`--sibling-index: ${i + 1}`, `--mod-index: ${i % 2}`]
                data-image-group>
                <for|src| of=group>
                    <img src=src alt="">
                </for>
            </div>
        </for>
    </div>
</div>
